import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["id", "fullWidth", "className", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import classNames from 'classnames';
import { GridRow, GridCol } from '@lmig/lmds-react-grid';
import "./header.css";
/**
 * @see [LMDS Header documentation and examples](https://designsystem.lmig.com/components/page-structure/header/code)
 *
 * API:
 *
 * @implements [HeaderProps](https://designsystem.lmig.com/components/page-structure/header/code#header-props)
 * @extends [HTMLElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmlelement.html)
 */
export var Header = function Header(_ref) {
  var id = _ref.id,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    className = _ref.className,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("header", _extends({
    className: classNames('lm-Header', className),
    id: id,
    role: "banner"
  }, otherProps), fullWidth ? /*#__PURE__*/React.createElement("div", {
    className: "lm-Masthead"
  }, children) : /*#__PURE__*/React.createElement(GridRow, {
    mainGrid: !fullWidth
  }, /*#__PURE__*/React.createElement(GridCol, {
    base: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: "lm-Masthead"
  }, children))));
};
Header.propTypes = {
  /** Add an optional ID to this element: `<header class="lm-Header">`. */id: _pt.string,
  /** Add custom classes to this element: `<header class="lm-Header">`. */className: _pt.string,
  /**
     * If an edge-to-edge, gridless header is desired, set this to true.
     * @default false
     */
  fullWidth: _pt.bool,
  /** Header content gets rendered inside `<div class="lm-Masthead">`. */children: _pt.node
};